import React from 'react';
import { useParams } from 'react-router-dom';

import DesignItem from '@components/DesignItem';

import { STATIC_SET_CONSTANTS } from '@utils/Util';

const SampleDesignCard = ({
	sampleList,
	sampleInfo,
	selectedIds,
	setSelectedIds,
	openDesignViewModal,
	isCheckboxChecked
}) => {
	const { id } = useParams();
	const formatToDesignDocuments = (design = []) => {
		const designDocs = design?.setMemberSampleRequestItemResponseList?.map((item) => {
			return {
				id: item?.id,
				docUrl: item?.featureImageDocUrl,
				name: design?.name,
				docType: 'PRODUCT_DESIGN'
			};
		});
		return designDocs;
	};

	const onSelectFromImageView = (value) => {
		let modifiedList = value?.map((item) => {
			return {
				...item,
				id: item.itemId
			};
		});
		setSelectedIds([...modifiedList]);
	};

	const RenderDesignItem = ({
		design,
		index,
		sampleInfo,
		id,
		selectedIds,
		onSelectFromImageView,
		openDesignViewModal,
		isCheckboxChecked
	}) => {
		const designProps = {
			...design,
			designDocuments:
				design.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT
					? formatToDesignDocuments(design)
					: [{ docType: 'PRODUCT_DESIGN', docUrl: design?.featureImageDocUrl }],
			subCategory: design?.category,
			addedByName: design?.productCreator,
			addedAt: design?.productCreationDate,
			collectionName: sampleInfo?.collectionName,
			id: design?.productId,
			itemId: design?.id,
			collectionId: sampleInfo?.collectionId
		};

		if (design.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT) {
			return (
				<DesignItem
					design={designProps}
					fromPage="SAMPLE"
					isSet={true}
					sampleRequestId={id}
					key={`design_${index}`}
				/>
			);
		} else {
			return (
				<DesignItem
					design={designProps}
					fromPage="SAMPLE"
					index={index}
					selectedProducts={selectedIds}
					setSelectedProducts={(list) => onSelectFromImageView(list)}
					onClickDesignImage={() => openDesignViewModal(design, design.productId)}
					key={`design_${index}`}
					isMyDesignTabSelected={isCheckboxChecked(design)}
				/>
			);
		}
	};

	return (
		<div className="design-list-container">
			<div className={`design-list-row 'image-view'`}>
				{sampleList?.map((design, index) => (
					<RenderDesignItem
						design={design}
						index={index}
						sampleInfo={sampleInfo}
						id={id}
						selectedIds={selectedIds}
						onSelectFromImageView={onSelectFromImageView}
						openDesignViewModal={openDesignViewModal}
						isCheckboxChecked={isCheckboxChecked}
						key={`design_${index}`}
					/>
				))}
			</div>
		</div>
	);
};

export default SampleDesignCard;
